module.exports = __webpack_public_path__ + "static/media/scanner.83b65cc5.svg";